import React from "react";

export default function ActionBar({ children }) {
  return <div className="action-bar">{children}</div>;
}
